import React from "react";
import "./executionModeBadge.css";

export default function ExecutionModeBadge({ mode }) {
  const value = String(mode || "").toLowerCase();
  if (!["paper", "live"].includes(value)) return null;
  return <span className={`execution-mode-badge ${value}`}>{value.toUpperCase()}</span>;
}
